<template>
  <div class="main-background">
    <div class="noresult-screen-full">
      <div class="input-group">
        <search-icon class="search-input-icon" />
        <input
          type="text"
          placeholder="Пошук"
          v-model="searchLocalText"
          class="form-control search-text"
          id="search-input"
        />
      </div>
      <div v-if="!searchLocalText" class="search-filter">
        <div class="search-filter-btn">
          <button
            class="filter-button"
            @click="$emit('setIsChangePage', 'filter')"
          >
            <sliders-icon class="filter-button-icon" />
          </button>
        </div>
      </div>
    </div>

    <!-- category-slider -->
    <div class="filter-category-list">
      <div class="filter-category-item" @click="setCheckCategory({ id: 0 })">
        Всі
      </div>
      <div
        class="filter-category-item"
        @click="setCheckCategory(category)"
        v-for="category of allCategories"
        :key="category.id"
      >
        {{ category.name }}
      </div>
    </div>
    <!-- /category-slider -->

    <!-- banner-slider -->
    <div class="vue-carusel-banner">
      <carousel
        :per-page="1"
        :pagination-enabled="true"
        paginationPosition="bottom-overlay"
        paginationActiveColor="#16ABB8"
        paginationColor="#94e4ec"
        :autoplay="true"
        :loop="true"
        autoplayDirection="3000"
      >
        <slide
          v-for="item in allMainBunners"
          :key="item.id"
          class="custom-carusel-styles"
        >
          <img
            :src="item.img"
            :alt="item.name"
            @click="openProductPageInfo(item.product_id)"
            class="baner-image-style"
          />
        </slide>
      </carousel>
    </div>
    <!-- /banner-slider -->

    <!-- category-slider -->

    <div
      v-for="category of allHeaderCategories"
      :key="category.id"
      class="main-page-category-block"
    >
      <div v-if="category.products.length" class="main-page-categories-header">
        <p class="main-page-category-name">{{ category.name }}</p>
        <button
          @click="setOpenAllProducts(category)"
          class="main-page-all-category-button"
        >
          Всі товари
        </button>
      </div>
      <carousel
        v-if="category.products.length"
        :per-page="2"
        :pagination-enabled="false"
        :navigationEnabled="true"
        :navigationClickTargetSize="1"
        navigationNextLabel="＞"
        navigationPrevLabel="<"
      >
        <slide
          v-for="item in category.products"
          :key="item.id"
          class="custom-carusel-styles"
        >
          <div class="product-block" @click="setClickToProduct(item)">
            <img :src="item.img" :alt="item.name" class="product-image" />
            <div class="product-name-container">
              <p class="product-name">{{ item.name }}</p>
              <p class="product-price">{{ `${item.price} грн.` }}</p>
            </div>
          </div>
        </slide>
      </carousel>
    </div>

    <!-- /category-slider -->
  </div>
</template>

<script>
import { SearchIcon, SlidersIcon } from "vue-feather-icons";
import { mapMutations } from "vuex";

export default {
  name: "home-page",
  components: {
    SearchIcon,
    SlidersIcon,
  },
  props: {
    perPage: {
      type: String,
      required: false,
    },
    isShowPage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      caruselBunner: [],
      searchLocalText: "",
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.searchLocalText = this.getSearchText;
  },
  beforeMount() {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  },
  computed: {
    allHeaderCategories() {
      return this.$store.getters.allHeaderCategories;
    },
    allCategories() {
      return this.$store.getters.allCategories;
    },
    allMainBunners() {
      return this.$store.getters.allMainBunners;
    },
    perPageName() {
      return this.$store.getters.perPageName;
    },
    getSearchText() {
      return this.$store.getters.getSearchText;
    },
  },
  methods: {
    ...mapMutations([
      "setIsOpenProductInfo",
      "addPerPage",
      "setIsShowProducts",
      "setChangeSearchText",
      "setCheckedCategory",
    ]),
    searchProducts() {
      if (this.searchLocalText.length < 3) {
        return;
      }
      try {
        let data = {
          q: this.searchLocalText,
          category_ids: null,
          price_from: 0,
          price_to: 999999,
        };
        this.$store.dispatch("searchedProducts", data);
        this.$emit("setIsChangePage", "product");
      } catch (error) {
        console.log(error.message);
      }
    },
    setOpenAllProducts(value) {
      this.setCheckedCategory(value);
      this.$emit("setIsOpenProductsPage", value.id);
    },
    setCheckCategory(value) {
      this.setCheckedCategory(value);
      if (value.id === 0) {
        this.$emit("setIsOpenProductsPage", null);
        this.setIsShowProducts("category");
      } else {
        this.$emit("setIsOpenProductsPage", value.id);
        this.setIsShowProducts("preCategory");
      }
    },
    setClickToProduct(value) {
      this.setIsOpenProductInfo(value);
      this.addPerPage("home");
      this.$emit("setIsChangePage", "productInfo");
    },
    async openProductPageInfo(id) {
      try {
        this.$store.dispatch("getOneProduct", id);
        setTimeout(() => {
          this.addPerPage("home");
          this.$emit("setIsChangePage", "productInfo");
        }, 500);
      } catch (error) {
        console.log(error.message);
      }
    },
  },
  watch: {
    searchLocalText(newValue, oldValue) {
      let val = oldValue;
      val;
      this.setChangeSearchText(newValue);
      this.searchProducts();
    },
  },
};
</script>

<style scoped>
.main-background {
  background: #fff;
  padding: 16px;
}
.bottombar {
  position: fixed;
  bottom: 0;
  left: 50%;
  padding: 12px 0px;
  z-index: 10;
  transform: translateX(-50%);
  width: 100%;
  max-width: 960px;
  margin: auto;
  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 0px 0px;
  background-color: rgba(255, 255, 255, 0.79);
  backdrop-filter: blur(10px);
}

.tabs-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  margin: auto;
}

.tabs-inner button {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #999999;
  margin: 0px 40px;
  position: relative;
}

.tabs-inner .tab.active {
  color: #2196f3;
}

.tabs-inner .tab.active svg {
  fill: #2196f3;
}

.tabs-inner button svg {
  width: 30px;
  height: auto;
  margin-bottom: 8px;
  fill: #999999;
}

.tabs-inner button .total-sum {
  position: absolute;
  font-size: 10px;
  width: 100%;
  top: 0;
  right: -32px;
  background: #2196f3;
  color: #fff;
  border-radius: 6px;
  padding: 2px 4px;
}

.to_order_menu_page {
  padding-top: 58px;
}

.to_order_title {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
}

.to_order_menu_container {
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ........................... */

.text-field {
  margin-bottom: 1rem;
}

.text-field__label {
  display: block;
  margin-bottom: 0.25rem;
  color: #757575;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.text-field__input {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #bdbdbd;
  border-radius: 12px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-field__input[type="search"]::-webkit-search-decoration,
.text-field__input[type="search"]::-webkit-search-cancel-button,
.text-field__input[type="search"]::-webkit-search-results-button,
.text-field__input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.text-field__input::placeholder {
  color: #212529;
  opacity: 0.4;
}

.text-field__input:focus {
  color: #212529;
  background-color: #fff;
  border-color: #bdbdbd;
  outline: 0;
}

.text-field__input:disabled,
.text-field__input[readonly] {
  background-color: #f5f5f5;
  opacity: 1;
}

/* with floating label */
.text-field_floating {
  position: relative;
}

.text-field_floating .text-field__input {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
  padding: 1rem 0.75rem;
}

.text-field_floating .text-field__label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.text-field_floating .text-field__input::-moz-placeholder {
  color: transparent;
}

.text-field_floating .text-field__input::placeholder {
  color: transparent;
}

.text-field_floating .text-field__input:focus,
.text-field_floating .text-field__input:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.text-field_floating .text-field__input:focus ~ .text-field__label,
.text-field_floating
  .text-field__input:not(:placeholder-shown)
  ~ .text-field__label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.75rem) translateX(0.15rem);
}

.wrong_label {
  color: #ff2c20;
}

.wrong_format_message {
  margin-top: 8px;
  color: #ff2c20;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.opened_input_options_container {
  width: 100%;
  position: relative;
}

.opened_input_result_text {
  position: relative;
  border-radius: 12px;
  border: 1px solid #bdbdbd;
  padding: 8px 16px;
  height: 58px;
}

.opened_input_results {
  position: absolute;
  width: 100%;
  border: 1px solid #bdbdbd;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
}

.opened_input_text {
  padding: 5px;
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.opened_input_icon {
  position: absolute;
  right: 20px;
  top: 18px;
  transition: all 0.5s ease;
}

.opened_input_rotate {
  transform: rotate(180deg);
}

.opened_input_placeholder {
  position: absolute;
  top: 18px;
  left: 10px;
  height: 100%;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  color: #757575;
  font-size: 16px;
  transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.active_opened {
  top: 6px;
  left: 10px;
  font-size: 13px;
}

.used_input_delivery_name {
  margin-top: 20px;
}

.small_inputs_container {
  display: flex;
  gap: 20px;
}

.error_number_icon {
  position: absolute;
  top: 18px;
  right: 20px;
  color: #ff2c20;
}

.success-payment-method-icon {
  position: absolute;
  top: 18px;
  right: 20px;
}

.send_order_button {
  padding: 16px 24px;
  width: 100%;
  border-radius: 12px;
  background: #1f1f1f;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

@media (min-width: 700px) {
  .to_order_menu_container {
    max-width: 50%;
  }
}

/* new styles */

.top-navbar_full {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 100px 16px 11px 16px;
}

.skip_btn a {
  color: #707070;
  text-align: right;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.noresult-screen-full {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.input-group {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
}

.form-control {
  padding: 8px 15px;
  border: 1px solid #eee;
  line-height: 22px;
  border-radius: 5px;
  font-size: 13px;
  color: #999;
}

input:focus,
input:active,
.form-control:focus,
.form-control:active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #eee;
  color: #777;
}

.search-text {
  background: #f0f0f0 !important;
  padding: 12px;
  border: none;
  color: #000;
  font-family: "Space Grotesk", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  padding-left: 50px;
}

.search-text::placeholder {
  color: #707070;
  font-family: "Space Grotesk", sans-serif;
}

.search-iconn:focus-visible,
.search-text:focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-filter-btn a {
  border-radius: 8px;
  background: #ff4c3b;
  padding: 12px;
  display: inline-block;
}

.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.filter-button-icon {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  color: #fff;
}

.filter-button {
  width: 48px;
  height: 48px;
  background: #01bace;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.nav-pills {
  display: flex;
  list-style: none;
}

.vue-carusel-container {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 24px;
}

.vue-carusel-banner {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 11px;
}

.custom-carusel-styles {
  width: auto !important;
}

.slide-category-button {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  background: transparent;
  color: #333;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  padding: 7px 10px;
}

.baner-image-style {
  width: 100%;
  cursor: pointer;
}

.filter-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.filter-category-item {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  background: #fff;
  padding: 7px 10px;
  cursor: pointer;
}

.main-page-category-block {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.main-page-category-name {
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  max-width: 70%;
}

.main-page-categories-header {
  display: flex;
  justify-content: space-between;
}
.main-page-all-category-button {
  background-color: transparent;
  border: none;
  color: #333;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
}

.product-block {
  width: 160px;
  border-radius: 12px;
  border: 2px solid #d2d6db;
  background: #f3f4f6;
  cursor: pointer;
  margin: 0 auto;
}
.product-image {
  width: 100%;
  height: 160px;
  border-radius: 10px 10px 0px 0px;
  border-bottom: 2px solid #d2d6db;
}
.product-name-container {
  padding: 7px;
}
.product-name {
  color: #333;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
}
.product-price {
  color: #01bace;
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}
</style>
